
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/identity",
      function () {
        return require("private-next-pages/identity/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/identity"])
      });
    }
  